// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"DeleteAppNewsModal_deleteButton__1l-VY"};